import { Component,OnInit } from '@angular/core';
import { NavController, NavParams,Refresher,LoadingController,ToastController,AlertController,ModalController } from 'ionic-angular';
import { Usuario } from '../../entities/usuario';
import { UsuarioDAO } from '../../daos/usuario-dao';
import { UsuarioNovoPage } from '../usuario-novo/usuario-novo';



@Component({
  selector: 'page-usuario-home',
  templateUrl: 'usuario-home.html',
})
export class UsuarioHomePage implements OnInit {
  public usuario: Usuario;
  public inspetores: Usuario[] = [];
  public inspetoresRaiz: Usuario[] = [];
  typeEmpresa: string;
  searchTerm: string;
  
  constructor(public navCtrl: NavController,private _loadingCtrl: LoadingController,
    private _toastCtrl: ToastController,
    private _modalCtrl: ModalController,
    private _alertCtrl: AlertController,
    private _usuarioDAO: UsuarioDAO,
    public navParams: NavParams) {
      this.usuario = navParams.get('usuario');
  }

  ngOnInit(): void {
    this.typeEmpresa = '1';
    this.obterUsuarios();
  }

  public obterUsuarios(refresher?: Refresher): void {
    let load = this._loadingCtrl.create({ content: 'Obtendo usuários...' });
    if (!refresher)
        load.present();
        this._usuarioDAO.obterUsuarioDaEmpresa(this.usuario.Empresa.Id).then(inspetores => {        
        this.inspetores = inspetores.filter(a => a.Ativo == "1");
        this.inspetoresRaiz = this.inspetores;
        this.inspetores = this.inspetores.filter(a => a.Empresa.Id == this.usuario.Empresa.Id);

        if (!refresher) load.dismiss(); else refresher.complete();
    }).catch(error => {
        console.error(error);
        if (!refresher) load.dismiss(); else refresher.complete();
        this._toastCtrl.create({
            message: 'Ocorreu um erro ao tentar obter os usuários. Tente novamente!',
            duration: 3000
        }).present();        
    });

  }

  public desativarUsuario(usuario: Usuario): void {
    this._alertCtrl.create({
        title: `Têm certeza que deseja desativar o usuáro ${usuario.Nome} ?`,
        subTitle: 'Após a confirmação, o usuário ficará desativado.',
        buttons: [
            {
                text: 'Cancelar',
                role: 'destructive'
            },
            {
                text: 'Confirmar',
                handler: () => {
                    this.salvarUsuario(usuario);
                }
            }
        ]
    }).present();
  }

  public salvarUsuario(usuario: Usuario): void {
    
    let load = this._loadingCtrl.create({ content: 'Salvando usuário...' });
    load.present();

    usuario.Ativo = "0";

    this._usuarioDAO.alterarUsuario(usuario).then(() => {
        load.dismiss().then(() => {
            this._toastCtrl.create({
                message: 'Usuário editado com sucesso!',
                duration: 3000
            }).present();
        });
    }).catch((erro) => {
        console.error(erro);
        load.dismiss();
        this._toastCtrl.create({
            message: 'Não foi possível editar o usuário, tente novamente!',
            duration: 3000
        }).present();
    });

    
  }

  public novoUsuario(): void {
    let modal = this._modalCtrl.create(UsuarioNovoPage, {usuario: this.usuario});

    modal.onDidDismiss(cadastrou => {      
        if (cadastrou)
        this.obterUsuarios();
    });

    modal.present();
  }

  public alterarEmpresa(ev: any): void {
    this.inspetores = this.inspetoresRaiz;
    this.inspetores = this.inspetores.filter(a => a.Empresa.Id == ev.value);
  }



}



// WEBPACK FOOTER //
// ./src/pages/usuario-home/usuario-home.ts